import React from "react";

import { Route, Switch, Redirect } from "react-router-dom";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actions from "./../Actions/Dashboard";
import * as sessionActs from "./../Actions/Session";
import * as modalActs from "./../Actions/Modal";
import * as systemActs from "./../Actions/System";

import Login from "./../Login/containers/LoginContainer";
import Dashboard from "./../Dashboard/HocDashboard";
import Home from "./../Home/containers/HomeContainer";

import NotFound from "../landing/components/NotFound404";
import { LOCAL_STORAGE } from "../constants/services/api";
import { sendService } from "../Services/service";

import InformeCreador from "./../CreacionInformes/containers/InformeContainer";
import InformeSemanal from "./../Infroms/containers/LandingInformContainer";
import Gis from "./../Dashboard/HocGis";
import Massive from "./../landing/containers/MassiveContainer";
import Individual from "./../landing/containers/IndividualContainer";
import LoadMap from "./../landing/containers/LoadMapContainer";
import CreateFenomene from "./../landing/containers/CreateFenomenesContainer";
import GenerateInform from "./../Infroms/containers/GenerateInformContainer";
import ModificateUser from "./../landing/containers/ModificateUserContainer";
import ChangePassword from "./../landing/containers/ChangePasswordContainer";
import ChangeLogos from "./../landing/containers/ChangeLogosContainer";
import CreateUser from "./../landing/containers/CreateUserContainer";
import FichaMunicipal from "./../FichaMunicipal/containers/FichaContainer";
import Piscc from "../PISCC/containers/PISCCContainer";
import CitizenPerception from "../CitizenPerception/containers/CitizenPerceptionContainer";
import Cruce from "../CruceLineas/containers/CruceHOC";
import EpContainer from "../Ep/containers/EpContainer";
import CensoGaleria from "../Ep/containers/CensoGaleria";
import Operativos from "../Ep/containers/Operativos";
import Publicidad from "../Ep/containers/Publicidad";
import Incautacion from "../Ep/containers/Incautacion";
import EpRequest from "../Ep/containers/Requests";
import EpResolve from "../Ep/containers/Resolve";
import EpDownloadExcel from '../Ep/containers/DownloadExcel'
import IepInform from '../Ep/containers/IepInfomr'

// const InformeCreador = lazy(() => import("./../CreacionInformes/containers/InformeContainer"));
// const InformeSemanal = lazy(() => import("./../Infroms/containers/LandingInformContainer"));
// const Gis = lazy(() => import("./../Dashboard/HocGis"));
// const Massive = lazy(() => import("./../landing/containers/MassiveContainer"));
// const Individual = lazy(() => import("./../landing/containers/IndividualContainer"));
// const LoadMap = lazy(() => import("./../landing/containers/LoadMapContainer"));
// const EpContainer = lazy(() => import("./../Ep/containers/EpContainer"));

// import Perception from '../Perception/Containers/PerceptionContainer';
// import Qualification from '../Qualification/Containers/QualificationContainer';
// import Victimization from '../Victimization/Containers/VictimizationContainer';
// import Line123 from '../CitizenPerception/containers/Line123Container';
// import Georeferencing from '../CitizenPerception/containers/GeoreferencingContainer';
// import Thefts from '../Thefts/Containers/TheftsContainer';
// import Piscc from '../Piscc/containers/PisccContainer';
// import WeekInform from './../Infroms/containers/InitInform';

class Routes extends React.Component {
  state = {
    on: false,
  };
  componentDidMount = async () => {
    const system = await sendService(
      "/api/v1/misc/getSystemConfig",
      "get"
    );
    if (system.status === 200) {
      this.props.systemActions.setUrlLogo(system.response.logo)
    }
    let on = false;
    if (!this.props.generals.noHeader) {
      if (window.location.pathname.toUpperCase().includes("NOHEADER")) {
        this.props.actions.noHeader();
      }
    }
    if (this.props.session.login !== "ok") {
      var session = localStorage.getItem(LOCAL_STORAGE);
      if (session !== null) {
        // console.log(this.props)
        const dataSesion = JSON.parse(session);
        const validateToken = await sendService(
          "/api/v1/users/tokenInfo",
          "get"
        );
        if (validateToken.status === 200) {
          this.props.sessionActions.login(dataSesion);
          on = true;
        } else {
          on = false;
        }
      }
      this.props.modalActions.closeLoader();
    } else {
      on = true;
    }

    this.setState({ on });
  };

  render() {
    if (this.props.session.login === "ok") {
      return (
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/Dashboard" strict component={Dashboard} />
          <Redirect from="/d" to="/Dashboard" />
          {/* <Suspense fallback={<div>Loading...</div>}>
          </Suspense> */}
          <Route path="/Informes" exact component={InformeCreador} />
          <Route path="/Gis" exact component={Gis} />
          <Route path="/Masivo" exact component={Massive} />
          <Route path="/Individual" exact component={Individual} />
          <Route path="/Carga-mapas" exact component={LoadMap} />
          <Route path="/Generar-informe" exact component={GenerateInform} />
          <Route path="/Administrar-usuario" exact component={ModificateUser} />
          <Route path="/Crear-usuario" exact component={CreateUser} />
          <Route path="/Crear-informe" exact component={InformeCreador} />
          <Route path="/Crear-fenomeno" exact component={CreateFenomene} />
          <Route path="/Cambiar-clave" exact component={ChangePassword} />
          <Route path="/Cambiar-logos" exact component={ChangeLogos} />
          <Route path="/Informe-semanal" exact component={InformeSemanal} />
          <Route path="/ep" exact component={EpContainer} />
          <Route path="/ep/censo" exact component={CensoGaleria} />
          <Route path="/ep/operativos" exact component={Operativos} />
          <Route path="/ep/archivos" exact component={EpDownloadExcel} />
          <Route path="/ep/publicidad" exact component={Publicidad} />
          <Route path="/ep/incautaciones" exact component={Incautacion} />
          <Route path="/ep/iep" exact component={IepInform} />
          <Route path="/ep/requests" exact component={EpRequest} />
          <Route path="/ep/resolve/:id" exact component={EpResolve} />
          <Route path="/Ficha-municipal" exact component={FichaMunicipal} />
          <Route path="/piscc" exact component={Piscc} />
          <Route path="/cruce" exact component={Cruce} />
          <Route
            path="/percepcion-ciudadana"
            exact
            component={CitizenPerception}
          />
          {/* <Route path="/percepcion" exact component={Perception} /> */}
          {/* <Route path="/calificacion" exact component={Qualification} /> */}
          {/* <Route path="/victimizacion" exact component={Victimization} /> */}
          {/* <Route path="/linea123" exact component={Line123} /> */}
          {/* <Route path="/georreferenciacion" exact component={Georeferencing} /> */}
          {/* <Route path="/hurtos" exact component={Thefts} /> */}
          {/* <Route path="/informe" exact component={WeekInform} /> */}
          <Route component={NotFound} />
        </Switch>
      );
    } else {
      return (
        <Switch>
          {/* <Route path="/Dashboard" strict component={Dashboard} />
                        <Redirect from='/d' to="/Dashboard" /> */}
          <Route component={Login} />
        </Switch>
      );
    }
  }
}

function mapStateToProps(state) {
  return {
    ...state,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
    sessionActions: bindActionCreators(sessionActs, dispatch),
    modalActions: bindActionCreators(modalActs, dispatch),
    systemActions: bindActionCreators(systemActs, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Routes);
